module.exports = __webpack_public_path__ + "static/media/logs-grey.ffb7c87d.svg";